import React, { FC, ReactElement, useEffect, useState } from "react";

import { Divider, TextField, Tooltip, useTheme } from "@mui/material";
import { useMsal } from "@azure/msal-react";

import delete_svg from "../../assets/delete.svg";
import conversation_svg from "../../assets/conversation.svg";
import { ReactComponent as ConversationIcon } from "../../assets/conversation.svg";
import { Edit, Download } from "@mui/icons-material";
import DeleteIcon from "@mui/icons-material/Delete";
import apiCall from "../../utils/apiCall";
import { getToken } from "../../utils/auth";
import {
  DELETE_CONVERSATION,
  GET_CONV_BY_USER_ID,
  UPDATE_CONVERSATION_NAME,
  DOWNLOAD_CONVERSATION,
} from "../../endpoint";

import { useAppDispatch, useAppSelector } from "../../hooks/reduxhook";
import {
  addConversations,
  addconversation,
  clearActiveChat,
  getconversationid,
  // limitChatHistory,
} from "../../redux/slices/conversationSlice";
import { loadingforconversation } from "../../redux/slices/loadingSlice";
import ConversationTitle from "./ConversationTitle";

import { addType, getType } from "../../redux/slices/typeSlice";
import types from "../../data/types";
import { removedrawerOpening } from "../../redux/slices/drawerOpening";
import { addModel, getModelDetails } from "../../redux/slices/modelSlice";
import { getChatHistory } from "../../redux/slices/userSlice";

import ConfirmDeleteModal from "../ConfirmDelete";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { Menu, MenuItem, IconButton } from "@mui/material";
import { addError } from "../../redux/slices/errorSlice";
import { getDefaultModel } from "./NewConversationButton";
import { DEFAULT_LLM_MODEL } from "../../data/constants";
interface i_conv {
  name: string;
  conversation_id: string;
  date?: string;
}
const ConversationList: FC<i_conv> = ({
  name,
  conversation_id,
  date,
}): ReactElement => {
  const dispatch = useAppDispatch();
  const current_conversation_id = useAppSelector(getconversationid);
  const type = useAppSelector(getType);
  const chatHistoryLimit = useAppSelector(getChatHistory);

  const models = useAppSelector(getModelDetails);

  // Parse name string to object
  const parseNameToObject = (nameStr: string) => {
    try {
      return JSON.parse(nameStr.replace(/'/g, '"'));
    } catch {
      return { result: nameStr };
    }
  };

  const nameObj = parseNameToObject(name);
  const displayName = nameObj.result || name;

  const formatDate = (dateStr: string) => {
    const date = new Date(dateStr);
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();
    const hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    const displayHours = hours % 12 || 12;
    return `${day}-${month}-${year} ${displayHours}:${minutes} ${ampm}`;
  };

  const [edit, setEdit] = useState(false);
  const [newName, setNewName] = useState(displayName);
  const [showConfirmDelete, setShowConfirmDelete] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const { accounts } = useMsal();
  const account = accounts[0];
  const theme = useTheme();
  useEffect(() => {
    setNewName(displayName);
  }, [displayName]);
  const deleteConversation = (e: any) => {
    e.stopPropagation();
    dispatch(loadingforconversation(true));
    apiCall("POST", DELETE_CONVERSATION, {
      conv_id: conversation_id,
      user_email: account.username,
    })
      .then((res) => {
        dispatch(addConversations(res?.result));
        dispatch(clearActiveChat());
      })
      .catch((err) => {
        dispatch(addError("Failed to delete a conversation.Please try again."));
      })
      .finally(() => {
        dispatch(loadingforconversation(false));
      });
  };
  const updateConvName = () => {
    dispatch(loadingforconversation(true));
    apiCall("POST", UPDATE_CONVERSATION_NAME, {
      conv_id: conversation_id,
      user_email: account.username,
      conv_name: newName,
    })
      .then((res) => {
        dispatch(addConversations(res?.result));
        setEdit(false);
      })
      .catch((err) => {
        dispatch(addError("Failed to update a conversation.Please try agian"));
      })
      .finally(() => {
        dispatch(loadingforconversation(false));
      });
  };
  const downloadConversation = (e: any) => {
    e.stopPropagation();
    dispatch(loadingforconversation(true));

    fetch(`${DOWNLOAD_CONVERSATION}/${conversation_id}/download`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    })
      .then((response) => {
        if (!response.ok) throw new Error("Download failed");
        return response.blob();
      })
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `conversation_${conversation_id}.docx`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      })
      .catch((err) => {
        dispatch(
          addError("Failed to download conversation. Please try again.")
        );
      })
      .finally(() => {
        dispatch(loadingforconversation(false));
      });
  };

  const selectConversation = async () => {
    dispatch(loadingforconversation(true));

    if (!type.type) {
      dispatch(addType(types[0]));
      dispatch(removedrawerOpening());
      dispatch(
        addModel(
          process.env?.REACT_APP_DEFAULT_LLM_MODEL ??
            getDefaultModel(models, DEFAULT_LLM_MODEL)
        )
      );
    }

    apiCall("POST", GET_CONV_BY_USER_ID, {
      conv_id: conversation_id,
    })
      .then(async (res) => {
        const c = [
          ...res.result.map((chat: any) => [
            {
              type: "user",
              message: chat.question,
              sources: [],
            },
            {
              type: "gpt",
              message: chat.answer,
              sources: chat.sources ?? [],
              chat_type: chat.chat_type,
              model: chat.model ?? chat.llm_doc,
              cypher: chat.cypher,
              org_cypher: chat.org_cypher,
              db_creds: chat.creds,
              image_model: chat.llm_img,
              collection_chunks: chat.chunks,
              collection_images: chat?.images,
              pii: chat?.pii,
              search_type: "similarity",
            },
          ]),
        ];
        const newchat: any[] = [];
        c.forEach(async (chat) => {
          newchat.push(chat[0]);
          newchat.push(chat[1]);
        });
        dispatch(
          addconversation({
            conversation_id,
            chats: newchat,
          })
        );

        // Apply chat history limit to the loaded conversation
        // if (chatHistoryLimit > 0) {
        //   dispatch(limitChatHistory(chatHistoryLimit));
        // }
      })
      .catch((err) => {
        dispatch(
          addError("Failed to load the chat for conversation.Please try again")
        );
      })
      .finally(() => {
        dispatch(loadingforconversation(false));
      });
  };
  const active = current_conversation_id === conversation_id;
  return (
    <>
      <div
        data-testid="chat-text"
        style={{
          padding: "12px 0px 12px 12px",
          cursor: "pointer",
          display: "flex",
          flexDirection: "column",
          borderRight: active
            ? `5px solid ${theme.palette.primary.main}`
            : "5px solid" + theme.palette.mode === "dark"
            ? "#666"
            : "#fff",
        }}
        onClick={selectConversation}
      >
        <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
          <ConversationIcon width={20} />
          &nbsp;&nbsp;
          {edit ? (
            <>
              <TextField
                value={newName}
                onChange={(e) => setNewName(e.target.value)}
                data-testid="name-input"
                onKeyDown={(e) => {
                  if (e.key === "Enter") updateConvName();
                }}
                size="small"
                onBlur={() => {
                  updateConvName();
                }}
              />
            </>
          ) : displayName.length > 25 ? (
            <Tooltip title={displayName}>
              <div
                style={{
                  flex: 1,
                }}
              >
                <ConversationTitle
                  title={displayName.substring(0, 25) + " ..."}
                  active={active}
                />
              </div>
            </Tooltip>
          ) : (
            <ConversationTitle title={displayName} active={active} />
          )}
          {edit ? (
            <TaskAltIcon
              color="primary"
              onClick={() => updateConvName()}
              sx={{
                mt: 0.4,
                cursor: "pointer",
              }}
            />
          ) : (
            <>
              <IconButton
                onClick={(e) => {
                  setAnchorEl(e.currentTarget);
                  e.stopPropagation();
                }}
                size="small"
              >
                <MoreVertIcon />
              </IconButton>
              <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={() => setAnchorEl(null)}
                onClick={(e) => e.stopPropagation()}
              >
                {/* <MenuItem
                  onClick={(e) => {
                    downloadConversation(e);
                    setAnchorEl(null);
                  }}
                >
                  <Download sx={{ mr: 1 }} />
                  Download
                </MenuItem> */}
                <MenuItem
                  onClick={(e) => {
                    setEdit(true);
                    setAnchorEl(null);
                    e.stopPropagation();
                  }}
                >
                  <Edit sx={{ mr: 1 }} />
                  Edit
                </MenuItem>
                <MenuItem
                  onClick={(e) => {
                    setShowConfirmDelete(true);
                    setAnchorEl(null);
                    e.stopPropagation();
                  }}
                >
                  <DeleteIcon sx={{ mr: 1 }} />
                  Delete
                </MenuItem>
              </Menu>
            </>
          )}
        </div>
        {date && (
          <div
            style={{
              fontSize: "12px",
              color: theme.palette.text.secondary,
              marginLeft: "32px",
              marginTop: "4px",
            }}
          >
            {formatDate(date)}
          </div>
        )}
      </div>
      <Divider
        sx={{
          width: "90%",
          margin: "auto",
          background: active
            ? theme.palette.primary.main
            : theme.palette.mode === "dark"
            ? "#333"
            : "#eee",
        }}
      />
      <ConfirmDeleteModal
        show={showConfirmDelete}
        cancel={() => setShowConfirmDelete(false)}
        confirm={deleteConversation}
      />
    </>
  );
};

export default ConversationList;
